import { AccountAPI } from "./apiUtils";

// http://localhost:3000/api/update-final-score-manual
export const getScoreUpdate = async (params) => await AccountAPI.post("/update-final-score-manual", params);